import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Tab from '../lifeInPayment/components/Tab';
import GreetingSection from '../../components/navbar/GreetingSection';
import MakeClaimPage from './detaile/MakeClaimPageForTabs';
import SubmitClaimsPlaceholder from './SubmitClaimsPlaceholder';
import { useGetAlertsNum } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';

interface LocationState {
  tabs?: number;
  policyNo?: string;
  alerts?: number;
}

const ClaimEnquiryPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { tabs, policyNo } = (location.state as LocationState) ?? {};
  const [tabIndex, setTabIndex] = useState(0);
  const { token, ready } = useKeycloakReady();
  const [randoms, setRandoms] = useState(Math.random());
  useEffect(() => {
    if (tabs !== undefined) {
      setTabIndex(tabs);
    }
  }, [tabs]);
  const { shouldFetch: shouldeFetchNum, data: alerts } = useGetAlertsNum(
    'useGetAlertsNum' + randoms,
    token ?? '',
    '02',
  );
  useEffect(() => {
    setRandoms(Math.random());
    shouldeFetchNum(ready);
  }, [ready, shouldeFetchNum]);

  return (
    <>
      <GreetingSection pageName={t('life.MakeClaim.ClaimsNotifications')} showicon={true} />
      <Tab
        values={[t('life.MakeClaim.title'), t('life.MakeClaim.submitClaims')]}
        selectedIndex={tabIndex}
        onTabPress={(index) => {
          setTabIndex(index);
        }}
        badges={[0, alerts ?? 0]} // Example: 0 hides badge, 5 shows badge with number 5
      />
      <div style={{ paddingTop: 0 }}>
        {tabIndex === 0 ? <MakeClaimPage policyNo={policyNo} /> : <SubmitClaimsPlaceholder />}
      </div>
    </>
  );
};

export default ClaimEnquiryPage;
